// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CheckboxStyle } from "@insite/mobius/Checkbox";
import { IconWrapper } from "@insite/mobius/Icon";
import { systemBuilderUnitarySpecificationViewStyles } from "@plumberssupply/App/Components/SystemBuilder/SystemBuilderUnitarySpecificationView";
import { color } from "@plumberssupply/XDL/Utilities";
import { css } from "styled-components";

systemBuilderUnitarySpecificationViewStyles.container = {
    css: css`
        display: flex;
        justify-content: center;
    `,
};

systemBuilderUnitarySpecificationViewStyles.wrapper = {
    css: css`
        width: 418px;
        display: flex;
        flex-direction: column;
        row-gap: 16px;
        padding: 12px;
        border: 1px solid ${color("common.ui7")};
    `,
};
systemBuilderUnitarySpecificationViewStyles.divider = {
    css: css`
        width: 100%;
        height: 1px;
        border-top: 1px solid ${color("common.ui7")};
    `,
};
systemBuilderUnitarySpecificationViewStyles.buttonWrapper = {
    css: css`
        display: flex;
        justify-content: flex-end;
    `,
};
systemBuilderUnitarySpecificationViewStyles.checkBox = {
    css: css`
        label {
            font-size: 16px;
            line-height: 26px;
            font-weight: bold;
            margin-left: 13px;
        }
        &${CheckboxStyle} {
            & > div {
                height: 18px;
                width: 36px;
                span[class^="Slider"] {
                    width: 36px;
                    height: 18px;
                    ${IconWrapper}, svg {
                        width: 14px;
                        height: 14px;
                    }
                }
            }
        }
    `,
};
